"use strict";

/* ------------------------------------------------------------------ *
 * Mapper 12: MMC3-like (SL-5020B / Gouder SL-5020B)
 * ------------------------------------------------------------------ *
 * MMC3-like board with an outer CHR bank register at $4132 for
 * 512 KiB CHR-ROM support. MMC3A-specific IRQ behavior required.
 * Used by Dragon Ball Z 5, Ultimate Mortal Kombat III.
 * See https://www.nesdev.org/wiki/INES_Mapper_012
 */

function register(Mappers) {
  Mappers[12] = function (nes) {
    this.nes = nes;
  };

  Mappers[12].prototype = new Mappers[4](); // Inherit from MMC3

  Mappers[12].prototype.reset = function () {
    Mappers[4].prototype.reset.apply(this);
    this.chrBankHigh = 0; // Outer CHR A18 register (512 KiB CHR-ROM support)
  };

  Mappers[12].prototype.write = function (address, value) {
    // Outer CHR bank register at $4132 (and mirrors)
    if ((address & 0xe100) === 0x4100) {
      // ...B ...A
      //    |    +- CHR A18 when PPU A12=0
      //    +------ CHR A18 when PPU A12=1
      this.chrBankHigh = value & 0x03;
      this.updateChrBanks();
      return;
    }

    // Read at $4132 returns language bit (Chinese/English)
    if (
      (address & 0xe100) === 0x4100 &&
      address >= 0x4132 &&
      address <= 0x4132
    ) {
      // Language bit - hardcoded to 0 (Chinese) per known copies
      return 0;
    }

    // Delegate to MMC3 for all other registers
    Mappers[4].prototype.write.apply(this, arguments);
  };

  // Override updateChrBanks to incorporate the outer CHR bank register
  Mappers[12].prototype.updateChrBanks = function () {
    var s = this.bankSelect;

    if (this.chrAddressSelect === 0) {
      // Mode 0: two 2 KB at $0000/$0800, four 1 KB at $1000-$1C00
      this.load1kVromBank((s[0] | (this.chrBankHigh << 6)) & 0xff, 0x0000);
      this.load1kVromBank(
        ((s[0] + 1) | (this.chrBankHigh << 6)) & 0xff,
        0x0400,
      );
      this.load1kVromBank((s[1] | (this.chrBankHigh << 6)) & 0xff, 0x0800);
      this.load1kVromBank(
        ((s[1] + 1) | (this.chrBankHigh << 6)) & 0xff,
        0x0c00,
      );
      this.load1kVromBank((s[2] | (this.chrBankHigh << 6)) & 0xff, 0x1000);
      this.load1kVromBank((s[3] | (this.chrBankHigh << 6)) & 0xff, 0x1400);
      this.load1kVromBank((s[4] | (this.chrBankHigh << 6)) & 0xff, 0x1800);
      this.load1kVromBank((s[5] | (this.chrBankHigh << 6)) & 0xff, 0x1c00);
    } else {
      // Mode 1: four 1 KB at $0000-$0C00, two 2 KB at $1000/$1800
      this.load1kVromBank((s[2] | (this.chrBankHigh << 6)) & 0xff, 0x0000);
      this.load1kVromBank((s[3] | (this.chrBankHigh << 6)) & 0xff, 0x0400);
      this.load1kVromBank((s[4] | (this.chrBankHigh << 6)) & 0xff, 0x0800);
      this.load1kVromBank((s[5] | (this.chrBankHigh << 6)) & 0xff, 0x0c00);
      this.load1kVromBank(
        ((s[0] | (this.chrBankHigh << 6)) & 0xff) << 1,
        0x1000,
      );
      this.load1kVromBank(
        (((s[0] + 1) | (this.chrBankHigh << 6)) & 0xff) << 1,
        0x1400,
      );
      this.load1kVromBank(
        ((s[1] | (this.chrBankHigh << 6)) & 0xff) << 1,
        0x1800,
      );
      this.load1kVromBank(
        (((s[1] + 1) | (this.chrBankHigh << 6)) & 0xff) << 1,
        0x1c00,
      );
    }
  };

  Mappers[12].prototype.toJSON = function () {
    var s = Mappers[4].prototype.toJSON.apply(this);
    s.chrBankHigh = this.chrBankHigh;
    return s;
  };

  Mappers[12].prototype.fromJSON = function (s) {
    Mappers[4].prototype.fromJSON.apply(this, arguments);
    this.chrBankHigh = s.chrBankHigh;
    this.updateChrBanks();
  };
}

module.exports = { register: register };
